export const formatArrayToText = (array) =>
  array
    .toString()
    .replaceAll(",", ", ")
    .replace(/,([^,]*)$/, " e $1");
